import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import { MessageCircleHeart, BookOpen, Sparkles, Users, CalendarCheck, ShieldCheck, ArrowRight, PlayCircle } from 'lucide-react';
const moods = [{
  id: 'senang',
  label: 'Senang',
  emoji: '😊',
  color: 'bg-yellow-100 text-yellow-600 border-yellow-200'
}, {
  id: 'sedih',
  label: 'Sedih',
  emoji: '😢',
  color: 'bg-blue-100 text-blue-600 border-blue-200'
}, {
  id: 'cemas',
  label: 'Cemas',
  emoji: '😰',
  color: 'bg-purple-100 text-purple-600 border-purple-200'
}, {
  id: 'marah',
  label: 'Marah',
  emoji: '😠',
  color: 'bg-red-100 text-red-600 border-red-200'
}, {
  id: 'bingung',
  label: 'Bingung',
  emoji: '🤔',
  color: 'bg-orange-100 text-orange-600 border-orange-200'
}, {
  id: 'lelah',
  label: 'Lelah',
  emoji: '😮‍💨',
  color: 'bg-gray-100 text-gray-600 border-gray-200'
}];
const moodVideos: Record<string, {
  title: string;
  url: string;
}[]> = {
  senang: [{
    title: 'Shake It Off',
    url: 'https://www.youtube.com/embed/nfWlot6h_JM'
  }, {
    title: 'ME!',
    url: 'https://www.youtube.com/embed/FuXNumBwDOM'
  }, {
    title: '22',
    url: 'https://www.youtube.com/embed/AgFeZr5ptV8'
  }],
  sedih: [{
    title: 'All Too Well',
    url: 'https://www.youtube.com/embed/tollGa3S0o8'
  }, {
    title: 'Back to December',
    url: 'https://www.youtube.com/embed/QUwxKWT6m7U'
  }, {
    title: 'exile',
    url: 'https://www.youtube.com/embed/osdoLjUNFnA'
  }],
  cemas: [{
    title: 'Breathe',
    url: 'https://www.youtube.com/embed/V-H_xH5y110'
  }, {
    title: "Soon You'll Get Better",
    url: 'https://www.youtube.com/embed/tMoW5G5LU08'
  }, {
    title: 'The Archer',
    url: 'https://www.youtube.com/embed/8xg3vE8Ie_E'
  }],
  marah: [{
    title: 'Bad Blood',
    url: 'https://www.youtube.com/embed/QcIy9NiNbmo'
  }, {
    title: 'Look What You Made Me Do',
    url: 'https://www.youtube.com/embed/3tmd-ClpJxA'
  }, {
    title: 'Better Than Revenge',
    url: 'https://www.youtube.com/embed/x1bX3F7uTrg'
  }],
  bingung: [{
    title: 'the 1',
    url: 'https://www.youtube.com/embed/KsZ6tROaNFA'
  }, {
    title: 'cardigan',
    url: 'https://www.youtube.com/embed/K-a8s8OLBSE'
  }, {
    title: 'Enchanted',
    url: 'https://www.youtube.com/embed/igIfiqqVHtA'
  }],
  lelah: [{
    title: 'Daylight',
    url: 'https://www.youtube.com/embed/u1xrNaTO18A'
  }, {
    title: 'Begin Again',
    url: 'https://www.youtube.com/embed/cMPEd8m79Hw'
  }, {
    title: 'Long Live',
    url: 'https://www.youtube.com/embed/Zlot0i3Zykw'
  }]
};
export function Home() {
  const [selectedMood, setSelectedMood] = useState<string | null>(null);
  return <div className="w-full" data-id="element-405">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-pink-100/60 via-purple-50/40 to-blue-100/60 pt-20 pb-24 overflow-hidden" data-id="element-406">
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10" data-id="element-407">
          <div className="absolute top-10 left-10 w-32 h-32 bg-pink-300 rounded-full mix-blend-multiply filter blur-xl opacity-40 animate-float" data-id="element-408"></div>
          <div className="absolute top-40 right-20 w-48 h-48 bg-blue-300 rounded-full mix-blend-multiply filter blur-xl opacity-40 animate-float" style={{
          animationDelay: '1s'
        }} data-id="element-409"></div>
          <div className="absolute -bottom-10 left-1/3 w-40 h-40 bg-purple-300 rounded-full mix-blend-multiply filter blur-xl opacity-40 animate-float" style={{
          animationDelay: '2s'
        }} data-id="element-410"></div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative" data-id="element-411">
          <div className="text-center max-w-3xl mx-auto" data-id="element-412">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5
          }} data-id="element-413">
              <span className="inline-block py-1 px-3 rounded-full bg-gradient-to-r from-pink-200/40 to-blue-200/40 text-purple-700 font-semibold text-sm mb-6 border border-purple-200/50" data-id="element-414">
                Selamat Datang di CLBK 👋
              </span>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-gray-900 mb-6 leading-tight" data-id="element-415">
                Ruang aman untuk{' '}
                <span className="bg-gradient-to-r from-pink-500 to-blue-500 bg-clip-text text-transparent" data-id="element-416">
                  berbagi cerita
                </span>
                , menemukan solusi.
              </h1>
              <p className="text-lg md:text-xl text-gray-600 mb-10 leading-relaxed" data-id="element-417">
                Kami di sini bukan hanya untuk masalahmu, tapi untuk mendukung
                potensi terbaikmu. Bercerita tanpa dihakimi, berkembang dengan
                penuh empati.
              </p>

              <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-418">
                <Link to="/layanan" className="bg-gradient-to-r from-pink-400 to-blue-400 text-white px-8 py-4 rounded-full font-bold text-lg hover:from-pink-500 hover:to-blue-500 transition-all shadow-lg hover:shadow-xl hover:-translate-y-1 flex items-center justify-center gap-2" data-id="element-419">
                  <MessageCircleHeart size={24} data-id="element-420" />
                  Mulai Konseling
                </Link>
                <Link to="/tes" className="bg-white text-purple-700 border-2 border-purple-200 px-8 py-4 rounded-full font-bold text-lg hover:bg-gradient-to-r hover:from-pink-50 hover:to-blue-50 transition-all shadow-sm hover:shadow-md flex items-center justify-center gap-2" data-id="element-421">
                  <Sparkles size={24} data-id="element-422" />
                  Cek Minat Bakat
                </Link>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Mood Tracker Section */}
      <section className="py-16 bg-white" data-id="element-423">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-424">
          <div className="bg-gradient-to-br from-pink-100/80 via-purple-50/60 to-blue-100/80 rounded-3xl p-8 md:p-12 shadow-sm border border-purple-100/50" data-id="element-425">
            <div className="text-center mb-10" data-id="element-426">
              <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4" data-id="element-427">
                Bagaimana perasaanmu hari ini? 💭
              </h2>
              <p className="text-gray-600" data-id="element-428">
                Pilih mood kamu dan temukan lagu yang pas untuk menemanimu.
              </p>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-10" data-id="element-429">
              {moods.map(mood => <button key={mood.id} onClick={() => setSelectedMood(mood.id)} className={`flex flex-col items-center justify-center p-4 rounded-2xl border-2 transition-all duration-300 ${selectedMood === mood.id ? `${mood.color} scale-105 shadow-md` : 'bg-white border-gray-100 hover:border-gray-200 hover:bg-gray-50 text-gray-600'}`} data-id="element-430">
                  <span className="text-4xl mb-2" data-id="element-431">{mood.emoji}</span>
                  <span className="font-medium" data-id="element-432">{mood.label}</span>
                </button>)}
            </div>

            <AnimatePresence mode="wait" data-id="element-433">
              {selectedMood && <motion.div key={selectedMood} initial={{
              opacity: 0,
              height: 0
            }} animate={{
              opacity: 1,
              height: 'auto'
            }} exit={{
              opacity: 0,
              height: 0
            }} className="overflow-hidden" data-id="element-434">
                  <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100" data-id="element-435">
                    <div className="flex items-center gap-2 mb-6" data-id="element-436">
                      <PlayCircle className="text-accent" size={24} data-id="element-437" />
                      <h3 className="text-xl font-bold text-gray-800" data-id="element-438">
                        Playlist Taylor Swift untuk mood{' '}
                        <span className="capitalize text-primary" data-id="element-439">
                          {selectedMood}
                        </span>
                        -mu 🎵
                      </h3>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-440">
                      {moodVideos[selectedMood].map((video, idx) => <div key={idx} className="flex flex-col gap-2" data-id="element-441">
                          <div className="relative w-full pt-[56.25%] rounded-xl overflow-hidden shadow-sm bg-gray-100" data-id="element-442">
                            <iframe className="absolute top-0 left-0 w-full h-full" src={video.url} title={video.title} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen data-id="element-443"></iframe>
                          </div>
                          <p className="font-medium text-gray-700 text-center text-sm" data-id="element-444">
                            {video.title}
                          </p>
                        </div>)}
                    </div>
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>
        </div>
      </section>

      {/* Quick Access Cards */}
      <section className="py-16 bg-gradient-to-b from-white to-pink-50/30" data-id="element-445">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-446">
          <div className="text-center mb-12" data-id="element-447">
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-448">
              Layanan Kami
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-449">
              Berbagai fasilitas yang dirancang khusus untuk mendukung
              perkembangan pribadimu.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-450">
            <motion.div whileHover={{
            y: -5
          }} className="bg-white rounded-3xl p-8 shadow-sm border border-gray-100 transition-all hover:shadow-md" data-id="element-451">
              <div className="w-14 h-14 bg-primary-light/20 rounded-2xl flex items-center justify-center mb-6" data-id="element-452">
                <MessageCircleHeart className="text-primary-dark" size={32} data-id="element-453" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-454">
                Konseling Rahasia
              </h3>
              <p className="text-gray-600 mb-6 line-clamp-3" data-id="element-455">
                Bercerita dengan aman dan nyaman bersama konselor profesional.
                Tersedia pilihan online chat maupun tatap muka.
              </p>
              <Link to="/layanan" className="text-primary font-semibold flex items-center gap-2 hover:text-primary-dark transition-colors" data-id="element-456">
                Booking Sekarang <ArrowRight size={18} data-id="element-457" />
              </Link>
            </motion.div>

            <motion.div whileHover={{
            y: -5
          }} className="bg-white rounded-3xl p-8 shadow-sm border border-gray-100 transition-all hover:shadow-md" data-id="element-458">
              <div className="w-14 h-14 bg-accent-light/30 rounded-2xl flex items-center justify-center mb-6" data-id="element-459">
                <Sparkles className="text-accent-dark" size={32} data-id="element-460" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-461">
                Tes Minat & Bakat
              </h3>
              <p className="text-gray-600 mb-6 line-clamp-3" data-id="element-462">
                Kenali dirimu lebih dalam melalui tes RIASEC, gaya belajar, dan
                minat bakat untuk merencanakan masa depan.
              </p>
              <Link to="/tes" className="text-accent-dark font-semibold flex items-center gap-2 hover:text-accent transition-colors" data-id="element-463">
                Mulai Tes <ArrowRight size={18} data-id="element-464" />
              </Link>
            </motion.div>

            <motion.div whileHover={{
            y: -5
          }} className="bg-white rounded-3xl p-8 shadow-sm border border-gray-100 transition-all hover:shadow-md" data-id="element-465">
              <div className="w-14 h-14 bg-blue-100 rounded-2xl flex items-center justify-center mb-6" data-id="element-466">
                <BookOpen className="text-blue-600" size={32} data-id="element-467" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-468">
                Artikel Edukasi
              </h3>
              <p className="text-gray-600 mb-6 line-clamp-3" data-id="element-469">
                Kumpulan artikel terpercaya seputar kesehatan mental, tips
                belajar, relasi sosial, dan karier.
              </p>
              <Link to="/artikel" className="text-blue-600 font-semibold flex items-center gap-2 hover:text-blue-800 transition-colors" data-id="element-470">
                Baca Artikel <ArrowRight size={18} data-id="element-471" />
              </Link>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-16 bg-gradient-to-b from-pink-50/30 to-white" data-id="element-472">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-473">
          <div className="bg-gradient-to-r from-pink-400 via-purple-400 to-blue-400 rounded-3xl p-10 text-white shadow-lg relative overflow-hidden" data-id="element-474">
            <div className="absolute top-0 right-0 w-64 h-64 bg-white opacity-10 rounded-full -translate-y-1/2 translate-x-1/3" data-id="element-475"></div>
            <div className="absolute bottom-0 left-0 w-40 h-40 bg-pink-300 opacity-20 rounded-full translate-y-1/3 -translate-x-1/4" data-id="element-476"></div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative z-10 text-center divide-y md:divide-y-0 md:divide-x divide-white/20" data-id="element-477">
              <div className="p-4" data-id="element-478">
                <Users className="mx-auto mb-4 opacity-80" size={40} data-id="element-479" />
                <h4 className="text-4xl font-extrabold mb-2" data-id="element-480">500+</h4>
                <p className="text-pink-100 font-medium" data-id="element-481">Siswa Terlayani</p>
              </div>
              <div className="p-4" data-id="element-482">
                <CalendarCheck className="mx-auto mb-4 opacity-80" size={40} data-id="element-483" />
                <h4 className="text-4xl font-extrabold mb-2" data-id="element-484">1,200+</h4>
                <p className="text-purple-100 font-medium" data-id="element-485">Sesi Selesai</p>
              </div>
              <div className="p-4" data-id="element-486">
                <ShieldCheck className="mx-auto mb-4 opacity-80" size={40} data-id="element-487" />
                <h4 className="text-4xl font-extrabold mb-2" data-id="element-488">100%</h4>
                <p className="text-blue-100 font-medium" data-id="element-489">
                  Kerahasiaan Terjamin
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>;
}